import register from '../register';
import debounce from './util/debounce.js';

const rAF = window.requestAnimationFrame;
const cAF = window.cancelAnimationFrame;
const framerate = ( 1 / 60 ) * 1000;
const movement = 1.75;

let loop;
let ticking = false;
let state = 0;
let lastFrame = Date.now();

let ticker = document.querySelector('.ticker');
let tickerText = document.querySelector('.ticker-text');

let boundary;

function isMobile() {
  return window.innerWidth < 768;
}

function updateBoundary() {
  boundary = tickerText.offsetWidth;
}

function onResize() {
  if ( isMobile() ) {
    ticking = false;
    ticker.style.transform = '';
    return;
  }
  if ( !ticking ) {
    cAF( loop );
    ticking = true;
    rAF( tick );
  }
  updateBoundary();
}

function duplicateNode() {
  let cloned = tickerText.cloneNode( true );
  ticker.appendChild( cloned );
  cloned = tickerText.cloneNode( true );
  ticker.appendChild( cloned );
  updateBoundary();
}

function tick() {
  if ( ticking ) {
    let now = Date.now();
    let deltaT = now - lastFrame;
    let scale = Math.max( deltaT / framerate, 1 );
    state = ( movement * scale ) + state;

    ticker.style.transform = `translateX(-${ state }px)`;

    lastFrame = now;
    if ( state >= boundary ) {
      state = 0;
    }
    rAF( tick );
  }
}

function init() {
  duplicateNode();
  if ( !isMobile() ) {
    ticking = true;
    loop = rAF( tick );
  }
  window.addEventListener( 'load', updateBoundary );
  window.addEventListener( 'resize', debounce( onResize, 300 ) );
}

register( 'ticker-tape', init );

export default undefined;
